import head from 'lodash/head';
import size from 'lodash/size';
import { ACTIVE_DEALER_SESSION_KEY } from '../ShippingDetailsForm/PreferredDealer/constants';
export const getIsOnlyCachedDealer = (dealerList) => {
    const { vicinityId } = JSON.parse(sessionStorage.getItem(ACTIVE_DEALER_SESSION_KEY) ?? '{}');
    return size(dealerList) === 1 && head(dealerList)?.vicinityId === vicinityId;
};
